import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=13552c8d"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13552c8d')) {
      api.createRecord('13552c8d', component.options)
    } else {
      api.reload('13552c8d', component.options)
    }
    module.hot.accept("./picture.vue?vue&type=template&id=13552c8d", function () {
      api.rerender('13552c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/components/picture.vue"
export default component.exports